import API_PUBLIC_SERVICE from './http';

const PREFIX = 'services';

const pagePath = '/service';
const pagesRoute = {
  editPage: val => `${pagePath}/edit/${val}/`,
  addPage: () => `${pagePath}/add/`,
  listPage: () => `${pagePath}/list/`
};
const tableData = {
  tableName: '',
  tableHeader: [
    {
      id: 'code',
      key: 'code',
      disablePadding: false,
      numeric: false,
      label: 'Código'
    },
    {
      id: 'name',
      key: 'name',
      disablePadding: false,
      numeric: false,
      label: 'Nombre'
    },
    {
      id: 'riskIndicator',
      key: 'riskIndicator',
      disablePadding: false,
      numeric: false,
      style: {
        width: '130px'
      },
      label: 'Indicador de Riesgo'
    },
    {
      id: '_id',
      key: '_id',
      disablePadding: false,
      numeric: false,
      label: 'Acciones',
      style: {
        width: '130px'
      },
      actions: pagesRoute
    }
  ],
  getKeyTable: () => '_id',
  makeDataTable: value => value,
  hasAddOption: true,
  hasCheckbox: false,
  isAdvancedDateFilter: false,
  ...pagesRoute
};

const ServiceService = {
  path: PREFIX,
  ...API_PUBLIC_SERVICE,
  ...tableData
};

export default ServiceService;
